/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from 'react';
import {
    shape, string, bool, func, object,
} from 'prop-types';

// Material UI
import {
    DialogContent,
    DialogContentText,
    TextField,
    Grid,
    FormHelperText,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

// Helpers
import customBreakpoints from '../../../../../../../helpers/customBreakpoints';
import { secureProtocol } from '../../../../../utils/secureProtocol';

// Component
import CancelReasonListMenu from './CancelOrderReasonList';

const styles = (theme) => ({
    modalBodyTextContainer: {
        paddingTop: '10px !important',
        overflowX: 'hidden',
        overflowY: 'auto',
    },
    modalBodyText: {
        fontSize: '17px',
        color: 'black',
        marginLeft: '15px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            fontSize: '16px',
            padding: '5px',
            marginLeft: '0px !important',
        },
        padding: '0px 25px 5px 0',
    },
    reasonMessageContainer: {
        height: 'auto',
        margin: '0 15px',
        color: 'black',
        fontSize: '17px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            margin: '0px',
            fontSize: '14px',
        },
    },
    reasonMessageTitle: {
        color: 'black',
        marginBottom: '0px',
        padding: '0px 25px 5px 0',
        fontSize: '20px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            marginLeft: '0px',
            padding: '5px',
        },
    },
    reasonMessageTextField: {
        marginTop: '20px',
        [theme.breakpoints.down(customBreakpoints.tabPortrait)]: {
            marginLeft: '5px',
        },
    },
    reasonHelperText: {
        marginLeft: '0px',
    },
    mandatory: {
        color: theme.palette.error.main,
    },
});

const ModalBodyWrapper = (props) => {
    const {
        bodyText: {
            line1,
            line2,
            line3,
            cancelReasonTitle,
        },
        classes,
        isMobile,
        getCancelReason,
        isCancelReasonEnabled,
        intOrderNumberToCancel,
        getSelectedItemSummary,
    } = props;
    const maxLength = 256;
    const [cancelReason, setCancelReason] = useState('');
    const [cancelOtherReson, setCancelOtherReason] = useState('');
    const selectedItemSummary = getSelectedItemSummary ? getSelectedItemSummary() : {};
    const isShowSelectedItem = intOrderNumberToCancel && intOrderNumberToCancel !== '' && intOrderNumberToCancel !== 'all';
    const setOtherReason = (event) => {
        setCancelOtherReason(event.target.value);
    };

    useEffect(() => {
        if (cancelReasonTitle) {
            if (cancelReason === 'Other') {
                getCancelReason(cancelOtherReson);
            } else {
                getCancelReason(cancelReason);
            }
        }
    }, [cancelReason, cancelOtherReson]);

    return (
        <DialogContent className={classes.modalBodyTextContainer}>
            <DialogContentText>
                {line1 ? <p className={classes.modalBodyText}>{line1}</p> : ''}
                {line2 ? <p className={classes.modalBodyText}>{line2}</p> : ''}
                {line3 ? <p className={classes.modalBodyText}>{line3}</p> : ''}
                {isShowSelectedItem
                    ? (
                        <>
                            <p className={classes.modalBodyText} style={{ fontSize: '18px' }}>{`${selectedItemSummary.firstName} ${selectedItemSummary.lastName}`}</p>
                            {selectedItemSummary?.items?.map((item) => (
                                <Grid container xs={12} style={{ marginLeft: '3vw' }}>
                                    <Grid item xs={3} sm={2}>
                                        <img src={secureProtocol(item.prdImgTmn)} height="80%" width="80%" alt="product-image" />
                                    </Grid>
                                    <Grid item xs={9} sm={10}>
                                        <Grid item xs={12}>
                                            <FormHelperText className={classes.fontStyle}>
                                                {item.productName}
                                            </FormHelperText>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FormHelperText className={classes.fontStyle}>
                                                ${item.price}
                                            </FormHelperText>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))}
                        </>
                    ) : null}
            </DialogContentText>
            { cancelReasonTitle && isCancelReasonEnabled
            && (
                <Grid className={classes.reasonMessageContainer}>
                    <Grid item>
                        <p className={classes.reasonMessageTitle}>{cancelReasonTitle}</p>
                    </Grid>
                    <CancelReasonListMenu setCancelReason={setCancelReason} />
                    {cancelReason === 'Other'
                        && (
                            <Grid item className={classes.reasonMessageTextField}>
                                <p className={classes.reasonMessageTitle}>How can we improve your gifting experience?<span className={classes.mandatory}>*</span></p>
                                <TextField
                                    variant="outlined"
                                    multiline
                                    rows={isMobile || !isShowSelectedItem ? 4 : 2}
                                    fullWidth
                                    value={cancelOtherReson}
                                    onChange={setOtherReason}
                                    autoFocus
                                    inputProps={{ maxLength }}
                                    helperText={`${(cancelOtherReson?.length)}/${maxLength}`}
                                    FormHelperTextProps={{
                                        className: classes.reasonHelperText,
                                    }}
                                />
                            </Grid>
                        )}
                </Grid>
            )}
        </DialogContent>
    );
};

ModalBodyWrapper.defaultProps = {
    bodyText: {
        line1: '',
        line2: '',
        line3: '',
        cancelReasonTitle: '',
    },
    isMobile: false,
    getCancelReason: () => {},
    getSelectedItemSummary: () => {},
    isCancelReasonEnabled: false,
    intOrderNumberToCancel: '',
};

ModalBodyWrapper.propTypes = {
    bodyText: shape({
        line1: string.isRequired,
        line2: string.isRequired,
        line3: string,
        cancelReasonTitle: string,
    }),
    classes: object.isRequired,
    isMobile: bool,
    getCancelReason: func,
    isCancelReasonEnabled: bool,
    intOrderNumberToCancel: string,
    getSelectedItemSummary: func,
};

export default withStyles(styles)(ModalBodyWrapper);
